import toast from 'react-hot-toast';

export const isFormValid = (formData) => {
  if (formData.naziv === '' || formData.naziv === null) {
    toast.error('Naziv je obavezno polje.');
    return true;
  }
  if (
    formData.idTipaMasine === '' ||
    formData.idTipaMasine === null ||
    formData.idTipaMasine === 0
  ) {
    toast.error('Tip mašine  je obavezno polje.');
    return true;
  }
  if (
    formData.idKategorije === '' ||
    formData.idKategorije === null ||
    formData.idKategorije === 0
  ) {
    toast.error('Kategorija je obavezno polje.');
    return true;
  }
  if (formData.metadata === '' || formData.metadata === null) {
    toast.error('Metadata je obavezno polje.');
    return true;
  }
  return false;
};
